import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1 22C0.4 22 0 21.6 0 21V3C0 2.4 0.4 2 1 2H9.5C9.8 2 10.1 2.19999 10.3 2.39999L12 5H23C23.6 5 24 5.4 24 6V21C24 21.6 23.6 22 23 22H1ZM5.6928 12.7929L9.1928 9.29289L10.607 10.7071L7.81412 13.5L10.607 16.2929L9.1928 17.7071L5.6928 14.2071C5.30227 13.8166 5.30227 13.1834 5.6928 12.7929ZM13.393 10.7071L16.1859 13.5L13.393 16.2929L14.8072 17.7071L18.3072 14.2071C18.6977 13.8166 18.6977 13.1834 18.3072 12.7929L14.8072 9.29289L13.393 10.7071Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }